import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EsslAttendanceReport, EsslAttendanceReportModel, LatesReportModel, StaffParticularsModel, StaffPostDeptFormModel } from '../../models/Essl-Lates-Model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EsslService {

  constructor(private http:HttpClient) { }

  private baseUrl = environment.apiUrl;

  private esslUrl = `${this.baseUrl}`;
  // private url = 'http://172.16.0.19/dbapi';


  getEmployeeAttendance(attpostform: EsslAttendanceReportModel): Observable<any []> {
    return this.http.post<any []>(`${this.esslUrl}/essl/att`,attpostform);
  }

  getEmployeeReport(leavesForm: LatesReportModel): Observable<any []> {
    return this.http.post<any []>(`${this.esslUrl}/essl/staff`,leavesForm);
  }

  getLatesReport(latesForm: LatesReportModel): Observable<any []> {
    return this.http.post<any []>(`${this.esslUrl}/essl/mwlr`, latesForm);
  }

  getStaffParticulars(staffForm: StaffPostDeptFormModel): Observable<StaffParticularsModel []> {
    return this.http.post<StaffParticularsModel []>(`${this.esslUrl}/essl/staffparticulars`, staffForm);
  }

}


